/**
 * Created by fwt on 2019/3/11.
 */
import React, {Component} from "react";
import {connect} from "react-redux";
import './style.less';
import BindingModal from "../../components/BindingModal";
import ChangePhone from "../../components/ChangePhone";
import PayModal from "../../components/PayModal";
import {Toast} from "antd-mobile";
import {getUserInfo,walletBalance} from "../../service/homeService";
import storage from "../../utils/localStore";

const sculpture = require('../../common/image/sculpture.png');
const discount = require('../../common/image/discount.jpg');
const helpCenter = require('../../common/image/helpCenter.png');
const contacts = require('../../common/image/contacts.png');
const rider = require('../../common/image/rider.png');
const tuiguang = require('../../common/image/tuiguang.jpg');
const suggetion = require('../../common/image/suggetion.png');
const zhuxiao = require('../../common/image/zhuxiao.png');
const jifen = require('../../common/image/jifen.png');
const youhui = require('../../common/image/youhui.png');

@connect(
    state => ({userInfo: state.userInfo})
)

export default class Member extends Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            phone:'',
            name:'',
            photo:'',
            bindingModal:false,
            changePhoneModal:false,
            payModal:false,
            walletStatus:"",
            balance:"",
            signStatus:"",
        }
    }

    componentDidMount() {
        getUserInfo({token:this.props.userInfo.token,source:1}).then((res)=>{
            if(res.data.code === '0000'){
                let usr = {
                    token:this.props.userInfo.token,
                    phone: res.data.data.phone,
                    openid: res.data.data.openid,
                    nickname:res.data.data.nickname,
                    avatar:res.data.data.avatar,
                    integral:res.data.data.integral,
                    emergencyContact:res.data.data.emergencyContact,
                    idNum:res.data.data.idNum,
                    couponCount:res.data.data.couponCount,
                    userId:res.data.data.id,
                    isSalesman:res.data.data.isSalesman,
                    walletStatus:res.data.data.walletStatus,
                    signStatus:res.data.data.signStatus,
                    bindStatus:res.data.data.bindStatus,
                };
                if(res.data.data.walletStatus == 3){
                    walletBalance({token:this.props.userInfo.token,source:1}).then((res)=>{
                        if(res.data.code === '0000'){
                            this.setState({balance:res.data.data.balance,})
                        }else{
                            Toast.info(res.data.msg)
                        }
                    });
                }
                storage.setItem('usr', usr);
                this.setState({
                    phone:res.data.data.phone,
                    name:res.data.data.nickname,
                    photo:res.data.data.avatar,
                    count: res.data.data.integral,
                    couponCount: res.data.data.couponCount,
                    walletStatus:res.data.data.walletStatus,
                    signStatus:res.data.data.signStatus,
                    bindStatus:res.data.data.bindStatus,
                })
            }else{
                Toast.info(res.data.msg)
            }
        });
    }

    //路由跳转控制
    skip(params) {
        this.props.history.push(params);
    }
    onClose = (v) => {
        if(v){
            window.location.reload()
        }
        this.setState({bindingModal:false,changePhoneModal:false,payModal:false});
    };
    changePhoneClick(){
        this.setState({bindingModal:true,changePhoneModal:false,});
    }
    payType(e){
        if(e == ""){
            Toast.info("请选择支付方式");
            return
        }
        if(e == "工商银行支付"){
            this.props.history.push("/icbcBank");
        }
    }
    getWallet(){
        if(this.state.walletStatus == 0 || this.state.walletStatus == 2){
            return <div className="count">
                        <i className="icon iconfont iconzhanghu" />
                        <div className="integral">
                            <div>
                                <p>民途钱包暂未开通</p>
                                <p className="text">开通账户并充值将有机会获得每单随机立减哦！</p>
                            </div>
                        </div>
                        <div className="btn btns" onClick={() => this.skip(`/wallet`)}>立即开通</div>
                    </div>
        }
        if(this.state.walletStatus == 1){
            return <div className="count">
                <i className="icon iconfont iconzhanghu" />
                <div className="integral">
                    <div>
                        <p>等待审核</p>
                        <p className="text">开通账户并充值将有机会获得每单随机立减哦！</p>
                    </div>
                </div>
            </div>
        }
        if(this.state.walletStatus == 3){
            return <div className="count">
                <i className="icon iconfont iconzhanghu" />
                <div className="integral">
                    <div>
                        <p>账户余额 <span>{this.state.balance}</span></p>
                        {this.state.signStatus == 0 ?
                            <p className="text" style={{color:'red'}}>请尽快完成账户签约，以免影响钱包余额正常支付</p> :
                            <p className="text">乘车出行时可以使用余额直接支付！</p>
                        }
                    </div>
                </div>
                <div className="btn" onClick={() => this.props.history.push('/account',{signStatus:this.state.signStatus,bindStatus:this.state.bindStatus})}>查看账户</div>
                {/*<div className="btn" onClick={() => this.props.history.push('/account',{signStatus:this.state.signStatus,})}>查看账户</div>*/}
            </div>
        }
    }
    render() {
        return (
            <div className="member">
                <div className="header">
                    {
                        this.props.location.state ? (
                            <div className="personal">
                                <i className="icon iconfont iconfanhui" onClick={() => this.props.history.push('/pay/home')}/><span>个人中心</span>
                            </div>
                        ):null
                    }

                    <div className="headContent">
                        {/*<div onClick={()=>this.setState({payModal:true})}><img src={this.state.photo === '' ? sculpture : this.state.photo}/></div>*/}
                        <div><img src={this.state.photo === '' ? sculpture : this.state.photo}/></div>
                        <div className="mobile">
                            <div>{this.state.name}</div>
                            <div>{this.state.phone}</div>
                        </div>
                        <div className="btn" onClick={()=>this.setState({changePhoneModal:true})}>更换手机号</div>
                    </div>
                    <div className="headCard">
                        <div onClick={() => this.props.history.push('/pay/myOrder',)}>
                            <div className="menu"><i className="icon iconfont iconhangcheng"/><span>订单</span></div>
                        </div>
                        <div onClick={() => this.skip('/applyInvoice')}>
                            <div className="menu"><i className="icon iconfont iconfapiaotubiao"/><span>发票</span></div>
                        </div>
                    </div>
                </div>
                <div className="discount">
                    <div onClick={() => this.skip('/discountPackage')} className="menu"><span>优惠套餐</span><img src={youhui}/></div>
                    {/*<div onClick={() => Toast.info("开发中",2)} className="menu" ><span>积分商城</span><img src={jifen}/></div>*/}
                </div>

                <div className="middle">
                    <div className="title">我的账户</div>
                    {this.getWallet()}
                    <div className="count">
                        <i className="icon iconfont iconjifen2" />
                        <div className="integral">
                            <div>
                                <p>剩余可用积分 <span>{this.state.count}</span></p>
                                <p className="text">购票可用积分作为现金抵扣</p>
                            </div>
                        </div>
                        {/*<div onClick={() => this.skip(`/share/${this.props.userInfo.userId}`)}>去赚积分</div>*/}
                        {/*<div onClick={() => this.skip(`/share`)}>赚积分</div>*/}
                        <div className="btn" onClick={() => Toast.info('当前活动已结束', 2)}>赚积分</div>
                    </div>
                    <div className="count" onClick={()=>this.props.history.push('/discounts')}>
                        <i className="icon iconfont iconyouhuiquan" />
                        <div className="integral">
                            <div>
                                <p>优惠券 <span>{this.state.couponCount}张</span></p>
                                <p className="text">购票时优惠券可与积分叠加使用</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/*<div className="advertisement" onClick={() => this.skip('/lineActivity')}>*/}
                {
                    this.props.userInfo.isSalesman == 1 || this.props.userInfo.isSalesman == undefined ? (
                        <div className="advertisement" onClick={() => this.props.history.push('/promote')}>
                            <img src={tuiguang}/>
                        </div>
                    ):null
                }

                <div className="advertisement" onClick={() => this.props.history.push('/exchangeCoupon')}>
                    <img src={discount}/>
                </div>
                <div className="bottom">
                    <div className="title">常用工具</div>
                    <div className="headCard">
                        <div onClick={() => this.skip('/contacts')}>
                            <img src={contacts}/>
                            <div className="menu">紧急联系人</div>
                        </div>
                        <div onClick={() => this.skip('/oftenPassenger')}>
                            <img src={rider}/>
                            <div className="menu">常用乘车人</div>
                        </div>
                        <div onClick={() => this.skip('/suggestion')}>
                            <img src={suggetion}/>
                            <div className="menu">意见反馈</div>
                        </div>
                        <div onClick={() => this.skip('/helpCenter')}>
                        {/*<div onClick={() => this.skip('/identityBinding')}>*/}
                            <img src={helpCenter}/>
                            <div className="menu">帮助中心</div>
                        </div>
                        <div onClick={() => this.skip('/cancellation')}>
                            <img src={zhuxiao}/>
                            <div className="menu">账号注销</div>
                        </div>
                    </div>
                </div>
                <div className="contactUs">客服电话：<a href="tel:400-138-9889">400 - 138 - 9889</a></div>
                <ChangePhone
                    modal={this.state.changePhoneModal}
                    onClose={this.onClose.bind(this)}
                    changePhoneClick={this.changePhoneClick.bind(this)}
                    {...this.props}
                />
                <BindingModal
                    modal={this.state.bindingModal}
                    onClose={this.onClose.bind(this)}
                    detele={true}
                    {...this.props}
                />
                <PayModal
                    modal={this.state.payModal}
                    onClose={this.onClose.bind(this)}
                    payType={this.payType.bind(this)}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/index.js